'use strict';

import { documentReady } from "./Shared/DocumentReady";
import '../css/components/slider.scss';
import '../css/pages/provider-detail.scss';
import '../css/components/tag.scss';
import SingleLocationMap from "./Map/SingleLocationMap";
import Slider from "./Slider/Slider";
import MainSearchBar, { EVENT_SEARCH_SUBMIT } from "./MainSearchBar/MainSearchBar";
import SearchAddressAutocompleteField from "./SearchAddressAutocompleteField/SearchAddressAutocompleteField";
import SearchCatTagAutocompleteField from "./SearchCatTagAutocompleteField/SearchCatTagAutocompleteField";

documentReady(() => {
    window.super();
    const script = document.querySelector('script[src^="/assets/provider-detail.bundle.js"]');
    const lat = script.getAttribute('data-lat');
    const lng = script.getAttribute('data-lng');
    if (script.getAttribute('data-offering-mode') !== 'online' && document.querySelector('#map')) {
        new SingleLocationMap(`${lat},${lat},${lng},${lng}`, 0.5);
    }
    new Slider('#slider-provider-detail');
    const mainSearchBar = new MainSearchBar(
        new SearchAddressAutocompleteField(),
        new SearchCatTagAutocompleteField()
    );
    mainSearchBar.addEventListener(EVENT_SEARCH_SUBMIT, () => {
        mainSearchBar.elements.mainSearch.submit();
    });
});
